<template>
  <div class="card-repeat" v-if="productItem">
    <div class="product-info">
      <h2 class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i
            class="mr8"
            :class="[productItem.isVeg ? 'tag-veg' : 'tag-non-veg']"
          ></i>
          <span class="product-title bold">{{ productItem?.displayName }}</span>
        </div>
        <span class="product-title bold">{{ priceProduct }}</span>
      </h2>
      <div class="d-flex justify-content-between align-items-center mt5">
        <ul v-if="itemsInCombo" class="justify-content-between fs-12 lh18">
          <li
            class="color-grey disc-list"
            v-for="(item, index) in itemsInCombo"
            :key="index"
          >
            {{ productObj[item]?.name }}
          </li>
        </ul>
        <ul v-else class="justify-content-between fs-12 lh18">
          <li class="color-grey disc-list">
            {{ productItem?.selectedVariant?.name }}
          </li>
        </ul>
        <div v-if="showEditMiniCartModal">
          <div
            class="btn cta-edit medium"
            v-if="itemsQuantityMiniCartCust[dataKey] > 0"
          >
            <span
              class="anim-ico-minus item-status-anim"
              @click="
                $emit('removeFromCartForCombo', itemsListMiniCartCust[dataKey])
              "
            >
            </span>
            <span class="bg-white item-quantity">{{
              itemsQuantityMiniCartCust[dataKey]
            }}</span>
            <span
              class="anim-ico-plus tr item-status-anim"
              @click="
                $emit('addToCartForCombo', itemsListMiniCartCust[dataKey])
              "
            ></span>
          </div>
          <div
            v-else
            class="btn medium bold hand cta-add"
            @click="$emit('addToCartForCombo', productItem)"
          >
            Add <span class="ico-plus">&#43;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RepeatEditProductCart",
  props: {
    dataItem: { required: true, default: {} },
    dataKey: { required: false, default: "" },
  },
  data() {
    return {
      productItem: {},
      productsFilteredArray: [],
      productObj: {},
      priceProduct: 0,
    };
  },
  mounted() {
    this.productItem = this.dataItem;
    this.productsFilteredArray = Object.values(
      this.$store.state.ProductItems.productsFiltered
    );
    this.productObj = this.productsFilteredArray.reduce(
      (pv, cv) => Object.assign(pv, cv),
      {}
    );
    this.priceProduct = this.productItem?.selectedVariant
      ? parseFloat(
          this.productItem?.selectedVariant?.price?.currentPrice.toFixed(2)
        )
      : parseFloat(this.productItem?.price?.currentPrice.toFixed(2));
  },
  computed: {
    itemsInCombo() {
      let productItemsIdArray = this.productItem?.selectedComboVariant
        ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
        .flat();
      return productItemsIdArray;
    },
    showEditMiniCartModal() {
      return this.$store.state.ProductItems.showEditMiniCartModal;
    },
    itemsQuantityMiniCartCust() {
      return this.$store.state.ProductItems.itemsQuantityMiniCartCust;
    },
    itemsListMiniCartCust() {
      return this.$store.state.ProductItems.itemsListMiniCartCust;
    },
  },
};
</script>
<style></style>
